<template>
  <div class="about">
    <div class="about-l">
      <div class="about-l-top">
        <!-- <img src="../assets/image/xt_bg.jpg" /> -->
      </div>
    </div>
    <div class="about-r"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Swipe from './swipe.vue';
// import Content from './Contentt.vue';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
    };
  },
  components: {
  },
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    async getProvince() {
      let result = await this.$api.instance.getProvince();
      console.log(result);
    },
    async getEducation() {
      let result = await this.$api.instance.getEducation();
      console.log(result);
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
.about {
  width: 1200px;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  .about-l{
    width:20%;
    &-top{
      height: 152px;
      background-image:url('../assets/image/xt_bg.jpg') ;
      position: relative;
      margin-top:-80px ;
      z-index: 2;
    }
  }
  .about-r{
    width:80%;
  }
  // background: #acbfa8;
}
</style>
